module.exports = __webpack_public_path__ + "img/michael-ricciardelli.cf9ea5eb.jpg";